export default __webpack_public_path__ + "static/media/womenBanner.9acb6693.svg";